import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private tokenService: TokenStorageService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const token = this.tokenService.getToken();

    if (token) {
      return true;
    } else {
      // si no está logueado, lo mando al login
      this.router.navigate(['/login']);
      return false;
    }
  }
}
